import React from 'react';

var Menu = function Menu(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.067 18C4.477 18 4 17.552 4 17s.478-1 1.067-1h13.866c.59 0 1.067.448 1.067 1s-.478 1-1.067 1H5.067zm0-5C4.477 13 4 12.552 4 12s.478-1 1.067-1h13.866c.59 0 1.067.448 1.067 1s-.478 1-1.067 1H5.067zm0-5C4.477 8 4 7.552 4 7s.478-1 1.067-1h13.866C19.523 6 20 6.448 20 7s-.478 1-1.067 1H5.067z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Menu.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Menu as icon };
export default iconHandler(Menu);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Menu.js
// module id = 610
// module chunks = 0